<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">

        <div v-if="user_projects == 0" class="card text-center mt-4">
          <div class="card-body">
            <h5 class="mt-2"><b>Hello {{ user.name }}</b></h5>
          <div class="mt-3">What do you want to create?</div>
          <div class="mt-4 mb-3">
            <div class="row">
              <div class="col text-center">
                <a href="/projects/new" class="btn btn-success mr-3">Project</a>
                <a href="/landing-pages/new" class="btn btn-danger">Landing Page</a>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div v-else class="row pb-3">
          <div class="col"><h5>My Projects</h5></div>
          <div class="col text-right" v-if="user.email_verified">
            <i v-if="creating" class="fas fa-spinner fa-spin fa-1x"></i>
            <div v-else>
              <div class="d-none d-md-table col pr-3"><a href="/projects/new" class="highlight">Start New Project</a></div>
              <div class="pr-3"><a href="/projects/new" class="d-md-none"><i class="fa-solid fa-circle-plus fa-2x debit"></i></a></div>
            </div>
          </div>
        </div>

       <b-card no-body v-if="user_projects > 0">
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Waiting for quote" title-link-class="darklink">
          <b-card-text><buyer-projects-list :status="0" :user="user" ref="BuyerProjects"></buyer-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Quote received" title-link-class="darklink">
          <b-card-text><buyer-projects-list :status="1" :user="user" ref="BuyerProjects"></buyer-projects-list></b-card-text>
        </b-tab>
        <b-tab title="In progress" title-link-class="darklink">
          <b-card-text><buyer-projects-list :status="2" :user="user" ref="BuyerProjects"></buyer-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Waiting for review" title-link-class="darklink">
          <b-card-text><buyer-projects-list :status="3" :user="user" ref="BuyerProjects"></buyer-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Completed" title-link-class="darklink">
          <b-card-text><buyer-projects-list :status="4" :user="user" ref="BuyerProjects"></buyer-projects-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
        
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  props: ['user','user_projects'],

  data() {
    return {
      tabIndex: 0,
      creating: false,
    };
  },

  created() {  },

  methods: {
    completeProfile() {
      this.sweetfire(
        "Please complete your profile then you can create a project"
      );
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        html: '<a href="/profile" target="_self" class="btn btn-success">Complete profile</a>',
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },
};
</script>